/**
 * Upload a file to S3 via presigned URL.
 */
export async function uploadFileToS3(file, { fileLocation = 'documents', customFilename } = {}) {
  const presignRes = await fetch('/api/s3/presigned-url', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      fileName: file.name,
      fileType: file.type,
      fileLocation,
      useCustomFilename: Boolean(customFilename),
      customFilename: customFilename || undefined
    })
  });
  const presignData = await presignRes.json();
  if (!presignData.success) {
    throw new Error(presignData.message || 'Failed to get presigned URL');
  }
  const { presignedUrl, s3Key, bucket, region } = presignData.data;
  const uploadRes = await fetch(presignedUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type || 'application/octet-stream' }
  });
  if (!uploadRes.ok) {
    throw new Error(`Upload failed: ${uploadRes.statusText}`);
  }
  return {
    url: `https://${bucket}.s3.${region}.amazonaws.com/${s3Key}`,
    mimeType: file.type || null,
    fileName: file.name,
    fileSizeBytes: file.size || null
  };
}
